/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import useStyles from "./styles";
import clsx from "clsx";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOffOutlined";
import VisibilityIcon from "@material-ui/icons/VisibilityOutlined";

import {
	Grid,
	Button,
	TextField,
	IconButton,
	InputAdornment,
	RadioGroup,
	FormControlLabel,
	Radio
} from "@material-ui/core";
import { connect } from "react-redux";
import { Images } from "config/images";
import { Controller, useForm } from "react-hook-form";
import {
	validatePasswordAction,
	deleteAccountAction,
	cancelDeleteAccountAction
} from "store/actions/LoginPageAction";
import { useHistory } from "react-router-dom";
import { DOMAIN } from "services/KidoConfigApi";
import DialogDeleteAccount from "./Components/DialogDeleteAccount";

const TYPE_DELETE = {
	DELETE_NOW: {
		name: "Xóa ngay",
		type: "DELETE_NOW"
	},
	DELETE_AFTER_7_DAYS: {
		name: "Xóa sau 7 ngày",
		type: "DELETE_AFTER_7_DAYS"
	},
	DELETE_AFTER_30_DAYS: {
		name: "Xóa sau 30 ngày",
		type: "DELETE_AFTER_30_DAYS"
	}
};

const DeleteAccountPage = props => {
	const { validatePassword, deleteAccount, cancelDeleteAccount, infoShop } =
		props;
	const history = useHistory();
	const classes = useStyles();

	const INACTIVE_DAY = infoShop?.inactiveDay;

	const [checkPass, setCheckPass] = useState(false);
	const [stepForm, setStepForm] = useState(1);
	const [dialogInfo, setDialogInfo] = useState({
		isOpen: false,
		title: ""
	});

	const {
		handleSubmit,
		control,
		formState: { errors }
	} = useForm();

	const onSubmit = data => {
		if (INACTIVE_DAY < 0) {
			if (stepForm === 1) {
				const { password } = data;
				const onSuccess = () => {
					setStepForm(stepForm + 1);
				};
				const dataSubmit = {
					password: password,
					onSuccess
				};
				validatePassword(dataSubmit);
			} else if (stepForm === 2) {
				const { typeDelete, reason } = data;
				const onSuccess = () => {
					setDialogInfo({
						isOpen: true,
						title: "Xóa tài khoản thành công"
					});
				};
				const dataSubmit = {
					type: typeDelete,
					reason: reason,
					onSuccess
				};
				deleteAccount(dataSubmit);
			}
		} else {
			const { password } = data;
			const onSuccess = () => {
				const onSuccessCancelDeleteAccount = () => {
					setDialogInfo({
						isOpen: true,
						title: "Hủy yêu cầu xóa tài khoản thành công"
					});
				};
				const dataSuccess = {
					onSuccess: onSuccessCancelDeleteAccount()
				};
				cancelDeleteAccount(dataSuccess);
			};
			const dataSubmit = {
				password: password,
				onSuccess
			};
			validatePassword(dataSubmit);
		}
	};

	const handleClose = () => {
		setDialogInfo({
			isOpen: false,
			title: ""
		});
	};

	const handleConfirm = () => {
		handleClose();
		window.location.replace(`${DOMAIN}/home`);
	};

	return (
		<Grid classes={{ root: classes.root }}>
			<form onSubmit={handleSubmit(onSubmit)}>
				<Grid classes={{ root: classes.body }}>
					<Grid classes={{ root: classes.rootForm }}>
						<Grid classes={{ root: classes.headerRegister }}>
							<img
								src={Images.logoDeleteAccount}
								alt="logoDeleteAccount"
								width={85}
								height={88}
							/>
							<Grid>
								<Grid classes={{ root: classes.titleHeader }}>
									{INACTIVE_DAY > 0 && stepForm === 2
										? "Hủy yêu cầu xóa tài khoản"
										: "Xóa tài khoản"}
								</Grid>
								<Grid
									classes={{ root: classes.subTitleHeader }}
								>
									{INACTIVE_DAY > 0 && stepForm === 2
										? "Để hủy yêu cầu, vui lòng nhập mật khẩu để thực hiện hủy yêu cầu"
										: "Trước khi xóa tài khoản, vui lòng nhập mật khẩu để tiếp tục tiến trình"}
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					{stepForm === 1 ? (
						INACTIVE_DAY > 0 ? (
							<Grid style={{ padding: "0px 20px" }}>
								<Grid classes={{ root: classes.rootHeader }}>
									<img
										src={Images.icWarning}
										alt="icWarning"
										width={24}
										height={24}
									/>{" "}
									Tài khoản của bạn sẽ bị xóa sau{" "}
									{INACTIVE_DAY} ngày
								</Grid>
								<Grid
									classes={{ root: classes.subTitleHeader }}
									style={{ marginLeft: 30 }}
								>
									Mọi thông tin cá nhân, lịch sử đơn hàng,
									thông tin tích lũy của bạn sẽ bị xóa vĩnh
									viễn
								</Grid>
								<Grid
									classes={{ root: classes.btnRejectAcc }}
									onClick={() => {
										setStepForm(stepForm + 1);
									}}
								>
									Hủy yêu cầu xóa tài khoản
								</Grid>
							</Grid>
						) : (
							<Grid classes={{ root: classes.rootForm }}>
								<Controller
									control={control}
									name="password"
									rules={{
										required: "Vui lòng nhập mật khẩu"
									}}
									render={({ field }) => (
										<TextField
											{...field}
											type={
												checkPass ? "text" : "password"
											}
											placeholder="Nhập mật khẩu"
											InputProps={{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={() => {
																setCheckPass(
																	!checkPass
																);
															}}
														>
															{checkPass ? (
																<VisibilityIcon />
															) : (
																<VisibilityOffIcon />
															)}
														</IconButton>
													</InputAdornment>
												)
											}}
											className={clsx(
												classes.customInput,
												errors?.password
													? classes.inputError
													: ""
											)}
										/>
									)}
								/>
								{errors?.password && (
									<Grid classes={{ root: classes.textError }}>
										{errors.password.message}
									</Grid>
								)}
							</Grid>
						)
					) : INACTIVE_DAY > 0 ? (
						<Grid classes={{ root: classes.rootForm }}>
							<Controller
								control={control}
								name="password"
								rules={{
									required: "Vui lòng nhập mật khẩu"
								}}
								render={({ field }) => (
									<TextField
										{...field}
										type={checkPass ? "text" : "password"}
										placeholder="Nhập mật khẩu"
										InputProps={{
											endAdornment: (
												<InputAdornment position="end">
													<IconButton
														aria-label="toggle password visibility"
														onClick={() => {
															setCheckPass(
																!checkPass
															);
														}}
													>
														{checkPass ? (
															<VisibilityIcon />
														) : (
															<VisibilityOffIcon />
														)}
													</IconButton>
												</InputAdornment>
											)
										}}
										className={clsx(
											classes.customInput,
											errors?.password
												? classes.inputError
												: ""
										)}
									/>
								)}
							/>
							{errors?.password && (
								<Grid classes={{ root: classes.textError }}>
									{errors.password.message}
								</Grid>
							)}
						</Grid>
					) : (
						<Grid style={{ padding: "0px 20px" }}>
							<Grid classes={{ root: classes.rootHeader }}>
								<img
									src={Images.icWarning}
									alt="icWarning"
									width={24}
									height={24}
								/>{" "}
								Tài khoản của bạn sẽ bị xóa vĩnh viễn
							</Grid>
							<Grid
								classes={{ root: classes.subTitleHeader }}
								style={{ marginLeft: 30 }}
							>
								Mọi thông tin cá nhân, lịch sử đơn hàng, thông
								tin tích lũy của bạn sẽ bị xóa vĩnh viễn
							</Grid>
							<Grid
								classes={{ root: classes.rootHeader }}
								style={{ marginTop: 10 }}
							>
								<img
									src={Images.icCalendar}
									alt="icCalendar"
									width={24}
									height={24}
								/>{" "}
								Chọn thời gian xóa tài khoản
							</Grid>
							<Controller
								control={control}
								name="typeDelete"
								rules={{
									required: "Vui lòng chọn thời gian xoá"
								}}
								render={({ field }) => (
									<RadioGroup
										{...field}
										style={{ marginLeft: 30 }}
									>
										{Object.keys(TYPE_DELETE).map(filed => (
											<FormControlLabel
												key={filed}
												value={TYPE_DELETE[filed].type}
												control={
													<Radio
														classes={{
															checked:
																classes.checkedRadio,
															root: classes.rootRadio
														}}
													/>
												}
												label={TYPE_DELETE[filed].name}
											/>
										))}
									</RadioGroup>
								)}
							/>
							{errors?.typeDelete && (
								<Grid
									classes={{ root: classes.textError }}
									style={{ marginLeft: 30 }}
								>
									{errors.typeDelete.message}
								</Grid>
							)}
							<Grid style={{ marginLeft: 30 }}>
								<Grid
									classes={{ root: classes.rootHeader }}
									style={{ padding: "10px 0px" }}
								>
									Lý do xóa tài khoản?
								</Grid>
								<Controller
									control={control}
									name="reason"
									render={({ field }) => (
										<TextField
											{...field}
											placeholder="Nhập lý do"
											minRows={3}
											multiline
											className={clsx(
												classes.customInput
											)}
										/>
									)}
								/>
								<Grid></Grid>
							</Grid>
						</Grid>
					)}
				</Grid>
				{stepForm === 1 && INACTIVE_DAY > 0 ? null : (
					<Grid classes={{ root: classes.rootFooter }}>
						<Grid classes={{ root: classes.bodyBtnSubmit }}>
							<Button
								type="submit"
								disabled={!errors}
								classes={{ root: classes.btnSubmit }}
							>
								{stepForm === 2 && INACTIVE_DAY < 0
									? "Xác nhận"
									: "Tiếp tục"}
							</Button>
						</Grid>
						<Grid classes={{ root: classes.bodyBtnSubmit }}>
							<Button
								variant="outlined"
								classes={{ root: classes.btnCancel }}
								onClick={() => {
									history.goBack();
								}}
							>
								Huỷ
							</Button>
						</Grid>
					</Grid>
				)}
			</form>
			<DialogDeleteAccount
				title={dialogInfo.title}
				open={dialogInfo.isOpen}
				handleClose={handleClose}
				handleConfirm={handleConfirm}
			/>
		</Grid>
	);
};

const mapStateToProps = state => {
	return {
		infoShop: state.homePageReducer.infoShop
	};
};

const mapDispatchToProps = dispatch => {
	return {
		validatePassword: data => {
			dispatch(validatePasswordAction(data));
		},
		deleteAccount: data => {
			dispatch(deleteAccountAction(data));
		},
		cancelDeleteAccount: data => {
			dispatch(cancelDeleteAccountAction(data));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAccountPage);
